"use client";
import { BlogDigest } from "trimble-terra";
import { useState } from "react";
import BlogArticleSearch from "./Search/BlogArticleSearch";
import { getProfile } from '@/profiles/getProfile'

export const BlogDigestWrapper = (
  formattedBlogDigest: any
) => {
  const config = formattedBlogDigest?.config
  const [currentBlogSearchTerm, setCurrentBlogSearchTerm] = useState("")
  const [articleSearchModalOpen, setArticleSearchModalOpen] = useState(false)
  
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE)
  const searchComponentModalToggleHandler = () => {
    setArticleSearchModalOpen(!articleSearchModalOpen)
  }

  const handleSearch = (value: string) => {
    setCurrentBlogSearchTerm(value)
    // navigate(`?blog-search=${value}`, { replace: false })
    searchComponentModalToggleHandler()
  }
  
  const handleChange = (value: string) => {
    setCurrentBlogSearchTerm(value)
  }

  const algoliaData = { 
    algoliaId: profile.NEXT_PUBLIC_ALGOLIA_APP_ID, 
    algoliaKey: profile.NEXT_PUBLIC_ALGOLIA_API_KEY, 
    algoliaIndex: profile.NEXT_PUBLIC_ALGOLIA_SITE_INDEX, 
    algoliaHits: profile.NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE || 10 
  }

  const validSearchClient = profile.NEXT_PUBLIC_ALGOLIA_APP_ID && 
  profile.NEXT_PUBLIC_ALGOLIA_API_KEY && 
  profile.NEXT_PUBLIC_ALGOLIA_SITE_INDEX

  return (
    <>
      <BlogDigest {...formattedBlogDigest} onSearch={handleSearch} onChange={handleChange} /> 
      {validSearchClient && (
      <BlogArticleSearch
        locale={formattedBlogDigest?.lang}
        articleSearchModalOpen={articleSearchModalOpen}
        setArticleSearchModalOpen={setArticleSearchModalOpen}
        title={formattedBlogDigest?.blogSearchTitle}
        description={formattedBlogDigest?.blogSearchDescription}
        eyebrow={formattedBlogDigest?.blogSearchEyebrow}
        searchPlaceholderText={formattedBlogDigest.searchPlaceholderText}
        searchTerm={currentBlogSearchTerm}
        resetButtonText={formattedBlogDigest.blogSearchResetText}
        algoliaData={algoliaData}
        profile={profile}
      />
    )}
    </>
  )
}